import { Observable } from 'rxjs';

import './../extensions/parse+rx';
import './../extensions/reg-exp+escape';

import { Pagination, Sort, ParseObject } from './../data';

export class ParseQuery<T extends Parse.Object> extends Parse.Query<T> {
  public orQuery(queries: Parse.Query[]) {
    this['_orQuery'] (queries);
    return this;
  }

  public searchKey(key: string, searchText: string) {
    return this.matches(key, RegExp.escape(searchText), 'i');
  }

  public pagination(pagination: Pagination) {
    this.limit(pagination.pageSize).skip(pagination.pageSize * (pagination.page - 1));
    return this;
  }

  public sort(sort: Sort) {
    if (sort && sort.sortKey) {
      sort.ascending ? this.addAscending(sort.sortKey) : this.addDescending(sort.sortKey);
    }
    return this;
  }

  public andQuery(query: Parse.Query) {
    this.matchesKeyInQuery(ParseObject.OBJECT_ID_KEY, ParseObject.OBJECT_ID_KEY, query);
    return this;
  }

  public includeTranslation(key:string, lang: string) {
    this.include(key + '_' + lang);
    return this;
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/queries/parse-query.ts